<template>
  <section id="landing-packets">
    <header class="landing-default">
      <h3>Pakiety samych korzyści</h3>
    </header>
    <packets-period></packets-period>
    <div class="flex">
      <div class="packet-box">
        <div class="packet mini">
          <router-link class="default" to="/pakiety">Sprawdź</router-link>
          <div class="content">
            <div class="icon"></div>
            <h5>Pakiet Mini</h5>
            <h4>{{ prices.mini[monthActive] }} PLN</h4>
            <p>netto | m-c</p>
          </div>
        </div>
        <ul>
          <li>
            <i class="material-icons">done</i>
            <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>odbieranie korespondencji przychodzącej</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>prowadzenie elektronicznego dziennika korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>dostęp 24/7 do dziennika korespondencji</p>
          </li>
          <li class="gray">
            <i class="material-icons">close</i>
            <p>przesyłanie i dostęp do skanów korespondencji</p>
          </li>
          <li class="gray">
            <i class="material-icons">close</i>
            <p>sala konferencyjna 2h w miesiącu</p>
          </li>
          <li class="gray">
            <i class="material-icons">close</i>
            <p>wysyłka papierowej korespondencji raz w miesiącu</p>
          </li>
        </ul>
        <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(1)">Wybierz</router-link>
      </div>
      <div class="packet-box">
        <div class="packet standard">
          <router-link class="default" to="/pakiety">Sprawdź</router-link>
          <div class="content">
            <div class="icon"></div>
            <h5>Pakiet Standard</h5>
            <h4>{{ prices.standard[monthActive] }} PLN</h4>
            <p>netto | m-c</p>
          </div>
        </div>
        <ul>
          <li>
            <i class="material-icons">done</i>
            <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>odbieranie korespondencji przychodzącej</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>prowadzenie elektronicznego dziennika korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>dostęp 24/7 do dziennika korespondencji</p>
          </li>
          <li class="blue">
            <i class="material-icons">done</i>
            <p>przesyłanie i dostęp do skanów korespondencji</p>
          </li>
          <li class="gray">
            <i class="material-icons">close</i>
            <p>sala konferencyjna 2h w miesiącu</p>
          </li>
          <li class="gray">
            <i class="material-icons">close</i>
            <p>wysyłka papierowej korespondencji raz w miesiącu</p>
          </li>
        </ul>
        <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(2)">Wybierz</router-link>
      </div>
      <div class="packet-box">
        <div class="packet comfort">
          <router-link class="default" to="/pakiety">Sprawdź</router-link>
          <div class="content">
            <div class="icon"></div>
            <h5>Pakiet Komfort</h5>
            <h4>{{ prices.komfort[monthActive] }} PLN</h4>
            <p>netto | m-c</p>
          </div>
        </div>
        <ul>
          <li>
            <i class="material-icons">done</i>
            <p>rejestracja firmy pod adresem:<br> ul. Świeradowska 51-57, 50-559 Wrocław</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>odbieranie korespondencji przychodzącej</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>prowadzenie elektronicznego dziennika korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>powiadomienia e-mail o wpłynięciu korespondencji</p>
          </li>
          <li>
            <i class="material-icons">done</i>
            <p>dostęp 24/7 do dziennika korespondencji</p>
          </li>
          <li class="blue">
            <i class="material-icons">done</i>
            <p>przesyłanie i dostęp do skanów korespondencji</p>
          </li>
          <li class="blue">
            <i class="material-icons">done</i>
            <p>sala konferencyjna 2h w miesiącu</p>
          </li>
          <li class="blue">
            <i class="material-icons">done</i>
            <p>wysyłka papierowej korespondencji raz w miesiącu</p>
          </li>
        </ul>
        <router-link class="default" to="/zamowienie/krok/1" @click.native="changePacket(3)">Wybierz</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import PacketsPeriod from '@/components/PacketsPeriod.vue'

export default {
  name: 'LandingPackets',
  components: {
    PacketsPeriod
  },
  computed:{
    monthActive(){
      return this.$store.state.monthActive;
    },
    prices(){
      return this.$store.state.prices;
    }
  },
  methods: {
    changePacket(id){
      this.$store.commit('changePacket', id);
      if(typeof localStorage.packet == 'undefined'){
        localStorage.setItem('packet', id);
      }else{
        localStorage.packet = id;
      }
    },
  }
}
</script>

<style lang="scss">
  section#landing-packets { display: flex; flex-wrap: nowrap; flex-direction: column; justify-content: center; align-items: center; margin-bottom: 25px; }
  section#landing-packets div.flex { display: flex; flex-wrap: wrap; justify-content: center; }
  div.packet { width: 350px; height: 400px; margin: 50px 50px 0 50px; position: relative; }
  div.packet.mini { background: url('../assets/packet_mini.webp') no-repeat 50% 50%; }
  div.packet.standard { background: url('../assets/packet_standard.webp') no-repeat 50% 50%; }
  div.packet.comfort { background: url('../assets/packet_comfort.webp') no-repeat 50% 50%; }
  div.packet div.content { display: flex; flex-direction: column; justify-content: center; width: 100%; height: 230px; background: rgba(37, 37, 37, 0.9); }
  div.packet div.content div.icon { width: 64px; height: 64px; margin: 0 auto; background: url('../assets/packet_icon_white.webp') no-repeat 50% 50%; }
  div.packet div.content h5 { margin: 0; padding: 0; color: #fff; font-weight: 400; font-size: 22px; text-align: center; }
  div.packet div.content h4 { margin: 7px 0; padding: 0; color: #fff; font-weight: 600; font-size: 40px; text-align: center; }
  div.packet div.content p { margin: 0; padding: 0; color: #fff; font-size: 14px; text-align: center; }
  div.packet a.default { display: none; position: absolute; left: 50%; transform: translateX(-50%); bottom: -26.5px; }
  div.packet a.default:hover + div.content { background: rgba(255, 255, 255, 0.7); }
  div.packet a.default:hover + div.content div.icon { background: url('../assets/packet_icon_black.webp') no-repeat 50% 50%; }
  div.packet a.default:hover + div.content h5 { color: $fontBlack; }
  div.packet a.default:hover + div.content h4 { color: $fontBlack; }
  div.packet a.default:hover + div.content p { color: $fontBlack; }
  div.packet button.default { position: absolute; left: 50%; transform: translateX(-50%); bottom: -26.5px; }

  div.packet { height: 366px; }
  div.packet.mini { background: url('../assets/packet_mini_smaller.webp') no-repeat 50% 50%; }
  div.packet.standard { background: url('../assets/packet_standard_smaller.webp') no-repeat 50% 50%; }
  div.packet.comfort { background: url('../assets/packet_comfort_smaller.webp') no-repeat 50% 50%; }
  div.packet div.content div.icon { width: 40px; height: 40px;background: url('../assets/packet_icon_white_40.webp') no-repeat 50% 50%; }
  div.packet a.default:hover + div.content div.icon { background: url('../assets/packet_icon_black_40.webp') no-repeat 50% 50%; }
  div.packet div.content h5 { font-size: 17px; }
  div.packet div.content { height: 210px; }
  div.packet div.content h4 { font-size: 35px; }
  div.packet div.content p { font-size: 14px; }

  div.packet-box ul { width: 350px; margin: 0 auto; padding: 0; list-style: none; }
  div.packet-box ul li { display: flex; margin: 5px 0; padding: 7px; background: rgba(228, 228, 230, 1); color: $fontBlack; border-radius: 3px; }
  div.packet-box ul li i.material-icons { display: block; width: 24px; height: 24px; line-height: 20px; font-size: 24px; text-align: center; color: $orangeDark; }
  div.packet-box ul li.blue i.material-icons { color: $blueDark; }
  div.packet-box ul li.gray { opacity: 0.4; }
  div.packet-box ul li.gray i.material-icons { color: $grayLight; }
  div.packet-box ul li p { margin: 0 0 0 10px; padding: 0; font-size: 13px; line-height: 24px; }
  div.packet-box > a.default { display: block; width: 350px; margin: 5px auto; padding: 0; height: 40px; text-align: center; line-height: 38px; font-size: 16px; border: 2px solid $orangeDark; }
  div.packet-box > a.default:hover { height: 40px; padding: 0; }

  @media (max-width: 1350px) {
    div.packet { margin: 50px; }
    div.packet a.default { display: block; }
    div.packet-box ul { display: none; }
    div.packet-box > a.default { display: none; }
  }

  @media (max-width: 450px) {
    div.packet { width: calc(100vw - 40px); margin: 50px 0; }
  }
</style>
